import React from 'react';

const SortFilter = ({ sortOrder, handleSort }) => (
  <form className="sorter">
    <label htmlFor="gridSort">Sort by:</label>
    <select id="gridSort" onChange={handleSort} defaultValue={sortOrder}>
      <option value="low">MSRP (low to high)</option>
      <option value="high">MSRP (high to low)</option>
      <option value="alpha">Alphabetical</option>
      <option value="new">New Arrivals</option>
    </select>
  </form>
);

export default SortFilter;
